import React from 'react';
import { Check } from '@mui/icons-material';
import { styled, Typography } from '@mui/material';

interface SurgerieNewTabsProps {
  tab: number;
  setTab: (tab: number) => void;
  tabTitle: string[];
}

const StyledStepper = styled('nav')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
  gap: 0,
  padding: '12px 38px 16px',
  background: '#fff',
  borderBottom: '1px solid #e5e5e8',
  position: 'relative',
  '&:before': {
    content: '""',
    position: 'absolute',
    left: 44,
    right: 44,
    top: 26,
    height: 2,
    background: '#e5e5e8',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    rowGap: 12,
    padding: '10px 0 14px',
    '&:before': {
      display: 'none',
    },
  },
}));

const StepButton = styled('button')<{ active?: boolean; done?: boolean; available?: boolean }>(props => ({
  border: 0,
  background: 'transparent',
  cursor: props.available ? 'pointer' : 'default',
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 7,
  color: props.active || props.done ? '#4a0e1a' : '#8c7f85',
  opacity: props.available ? 1 : 0.55,
  fontFamily: 'inherit',
}));

const Marker = styled('span')<{ active?: boolean; done?: boolean }>(props => ({
  width: 34,
  height: 34,
  borderRadius: '50%',
  border: `2px solid ${props.active || props.done ? '#7b1235' : '#eadde1'}`,
  background: props.active ? '#7b1235' : '#fff',
  color: props.active ? '#fff' : '#7b1235',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 700,
  boxShadow: 'none',
}));

const SurgerieNewTabs: React.FC<SurgerieNewTabsProps> = ({ tab, setTab, tabTitle }) => {
  return (
    <StyledStepper aria-label="Etapas do orçamento">
      {tabTitle.map((title, index) => (
        <StepButton
          type="button"
          key={title}
          active={index + 1 === tab}
          done={index + 1 < tab}
          available={index + 1 <= tab}
          onClick={() => setTab(index + 1)}
        >
          <Marker active={index + 1 === tab} done={index + 1 < tab}>
            {index + 1 < tab ? <Check fontSize="small" /> : index + 1}
          </Marker>
          <Typography variant="caption" fontWeight={index + 1 === tab ? 700 : 500}>
            {title}
          </Typography>
        </StepButton>
      ))}
    </StyledStepper>
  );
};

export default SurgerieNewTabs;
